import React, { useState } from 'react';
import { Plus } from "lucide-react";
import { useTopics } from '../../../contexts/TopicContext';
import TopicModal from './TopicModal';
import TopicCard from '../../../components/ui/TopicCard';

function TopicManagementPage() {
    const { topics, removeTopic, loading } = useTopics();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentTopic, setCurrentTopic] = useState(null);

    const handleAddEdit = (topic = null) => {
        setCurrentTopic(topic);
        setIsModalOpen(true);
    };

    const handleDelete = async (topicId) => {
        await removeTopic(topicId);
    };

    if (loading) {
        return (
          <div className="p-4">
          <div className="animate-pulse space-y-4">
            <div className="h-6 bg-gray-300 rounded"></div>
            <div className="h-6 bg-gray-300 rounded"></div>
            <div className="h-6 bg-gray-300 rounded"></div>
          </div>
          </div>
        );
      }

    return (
        <div className='mt-4'>
            <div className="flex justify-between items-center mb-6">
                <h1 className="text-xl md:text-3xl font-oswald font-light">Topic Management</h1>
                <button onClick={() => handleAddEdit()} className="btn btn-primary">
                    <Plus className="w-4 h-4" />
                    Add Topic
                </button>
            </div>

            {/* Stats Cards */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
                <div className="stats shadow">
                    <div className="stat">
                        <div className="stat-title">Total Topics</div>
                        <div className="stat-value">{topics.length}</div>
                    </div>
                </div>
            </div>

            {topics.length === 0 ? (
                <div className="text-center text-gray-500">No topics available. Click "Add Topic" to create a new one.</div>
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {topics.map((topic) => (
                        <TopicCard 
                            key={topic.id} 
                            topic={topic}
                            onEdit={() => handleAddEdit(topic)}
                            onDelete={() => handleDelete(topic.id)}
                        />
                    ))}
                </div>
            )}
            <TopicModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                currentTopic={currentTopic}
            />
        </div>
    );
}

export default TopicManagementPage;